import { Middleware } from "@reduxjs/toolkit";
import { notification } from "antd";

import { clearError, setError } from "./errorSlice";
import { getErrorMessage } from "./utils";

export const errorToastMiddleware: Middleware = () => (next) => (action) => {
    if (setError.match(action)) {
        const message = getErrorMessage(action.payload);

        const key = `error_${Date.now()}`;

        notification.error({
            key,
            message: "Error",
            description: message,
            placement: "topRight",
            duration: 2,
            onClose: () => {
                next(clearError());
            },
        });
    }

    return next(action);
};
